import { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useBoundStore } from "useStore";
import { ExportCampaignManager } from "./utils/ExportCampaignManager";

export default function ExportButton() {
  const [loading, setLoading] = useState(false);

  const campaignManagerRows = useBoundStore((state) => state.campaignManagerRows);
  const cmEditedRows = useBoundStore((state) => state.cmEditedRows);

  const selectedRows = campaignManagerRows.filter((row) => cmEditedRows[row.id]);
  const isDisabled = selectedRows.length === 0;

  const handleExport = async () => {
    setLoading(true);
    try {
      await ExportCampaignManager.ExportCampaigns(selectedRows);
    } catch (error) {
      console.error("Error al exportar:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Exportar" placement="bottom" arrow>
      <span>
        <Button
          variant="contained"
          disabled={isDisabled || loading}
          sx={{
            backgroundColor: "#354887",
            "&:hover": { backgroundColor: "#354887" },
            height: "45px",
            width: "30.5px",
            textTransform: "uppercase",
            padding: 0,
          }}
          onClick={handleExport}
        >
          <FileDownloadOutlinedIcon sx={{ width: 30, height: 30 }} />
        </Button>
      </span>
    </Tooltip>
  );
}
